module.exports = __webpack_public_path__ + "static/assets/484c379b1da007ecb5f66780a119fa2e.mp3";